import { NgOptimizedImage } from '@angular/common';
import { Component, signal, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonLinkComponent } from '../shared/components/button-link/button-link.component';
import { HomeConnectorComponent } from './home-connector/home-connector.component';

@Component({
    selector: 'app-home',
    imports: [NgOptimizedImage, TranslateModule, ButtonLinkComponent, HomeConnectorComponent],
    templateUrl: './home.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./home.component.scss']
})
export class HomeComponent {
    protected readonly dashBoardRoute = signal<string>('/dashboard');
}
